export default __webpack_public_path__ + "static/media/lock.689e2097.svg";